import React from 'react'
import Header from './Header';
import Hero from './Hero';

const Home = ({lang, handleLanguageChangeA, handleLanguageChangeB}) => {
  return (
    <>
    <div className="min-h-screen bg-background bg-no-repeat bg-[length:80%-100%] sm:bg-left-top lg:bg-contain py-2">
      <Header lang={lang} handleLanguageChangeA={handleLanguageChangeA}
         handleLanguageChangeB={handleLanguageChangeB} />
      <Hero lang={lang} />
    </div>
    </>
  )
}

export default Home;    